import OpenAPIClientAxios from 'openapi-client-axios';
import EventBus from '../../layouts/slots/event-bus';
import config from '../../config';
import { rg4js } from '../../lib/raygun';
import { getUserStore, getAppStore } from '@/store';
import router from '../../router';

const api = new OpenAPIClientAxios({
  definition: `${config.VUE_APP_NUCLEUS_API}/swagger.json`,
  axiosConfigDefaults: {
    baseURL: config.VUE_APP_NUCLEUS_API,
  },
});

api.init();

let client = null;

const getClient = async () => {
  const appStore = getAppStore();

  if (appStore.onlineStatus === false) {
    throw new Error("Currently Offline");
  }

  if (!client) {
    client = await api.getClient();

    // RESPONSE INTERCEPTOR
    client.interceptors.response.use(
      response => response,
      error => {
        rg4js('send', {
          error,
          message: error.message,
        });
        const errorCodesToEmit = ['ERR_FORBIDDEN', 'ERR_PROVIDER_MISMATCH', 'ERR_NOT_FOUND', 'ERR_UNAUTHORIZED']
        const status = error?.response?.status;
        const code = error?.response?.data?.errorCode || '';
        const message = error?.response?.data?.message || error.message;
        const errorEvent = {
          statusCode: status,
          code : code,
          message : message
        }
        if(errorCodesToEmit.includes(code)) {
          EventBus.emit('error', errorEvent);
        }
        else {
          return Promise.reject({
                message: message,
          });
        }
        
      }
    );

    // REQUEST INTERCEPTOR
    client.interceptors.request.use(async config => {
      //await waitForAuthReady; 
    
      const userStore = getUserStore();
      const currentUser = userStore.currentUser;
    
      if (currentUser?.getIdToken) {
        config.headers.Authorization = await currentUser.getIdToken();
      }
    
      const org = router.currentRoute.value.query.org;
      if (org) {
        config.headers.OrganizationId = org;
      }
    
      return config;
    });
  }

  return client;
};

const handleSuccess = async response => ({
  data: response?.data || null,
});

export default {
  getClient,
  handleSuccess,
};